import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TeachersPerformanceReportFilterForm } from 'src/app/shared/interfaces';

import { DataWithPagination } from '../../interface';
import { TeachersPerformanceReportApi } from '../api/teachers-performance-report-api';
import { TeachersPerformanceReport } from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class TeachersPerformanceReportRepository extends Repository {
  constructor(private teachersPerformanceReportApi: TeachersPerformanceReportApi) {
    super();
  }

  getTeachersPerformanceReport(
    filter: TeachersPerformanceReportFilterForm
  ): Observable<DataWithPagination<TeachersPerformanceReport[]>> {
    return this.teachersPerformanceReportApi.getTeachersPerformanceReport(filter);
  }
}
